import { Action, Module, VuexModule } from "vuex-module-decorators";
import { RegulationNewsType } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class RegulationNewsTypeModule extends VuexModule {
    @Action
    [RegulationNewsType.listRegulationNewsType]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/regulation-news-type/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [RegulationNewsType.findPageRegulationNewsType](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/regulation-news-type`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [RegulationNewsType.saveRegulationNewsType](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/regulation-news-type/save`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [RegulationNewsType.deleteRegulationNewsType](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/regulation-news-type/delete`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}